export const data = [
    {
        name: 'Выручка, руб', 
        value: [500521, 2480521, 1450354, 2507894, 531230, 3510160, 4805121 ]
    },
    {
        name: 'Наличные', 
        value: [300000, 300000, 350000, 400000, 150000, 260000, 300000]
    },{
        name: 'Безналичный расчет', 
        value: [100000, 100000, 150354, 51230, 56800, 180000, 100000, ]
    },{
        name: 'Кредитные карты', 
        value: [100521, 100521, 150354, 51230, 56800, 180000, 100521, ]
    },{
        name: 'Средний чек, руб', 
        value: [1300, 900, 800, 900, 1000, 900, 900, ]
    },{
        name: 'Средний гость, руб', 
        value: [1200, 800, 900, 1000, 700, 700, 800 ]
    },{
        name: 'Удаление из чека (после оплаты), руб', 
        value: [1000, 1100, 800, 900, 700, 800, 900 ]
    },{
        name: 'Удаление из чека (до оплаты), руб', 
        value: [1300, 1300, 1200, 800, 700, 500, 900]
    },{
        name: 'Количество чеков', 
        value: [34, 36, 35, 31, 32, 34, 34 ]
    },{
        name: 'Количество гостей', 
        value: [34, 36, 35, 31, 32, 34, 32 ]
    }
];